import React from "react"
import { useForm } from "react-hook-form"

const FORM_URL =
  "https://docs.google.com/forms/u/0/d/e/1FAIpQLSe90D4_C2Hu1G3gSXP42TGb6UL6BAPX6OtB307Q1G_lgDsTjQ/formResponse"

const FormFieldNames = {
  name: "entry.216647470",
  age: "entry.1210289190",
  mailAddress: "entry.1295411609",
  tel: "entry.937771476",
  message: "entry.352692909",
  companyName: "entry.1163209293",
  inquiryType: "entry.1322806288",
}

const Form = ({
  showCompany = true,
  showAge = true,
  messageLabel = "メッセージ",
  from,
}) => {
  const { handleSubmit, register, setValue } = useForm({
    defaultValues: {
      name: "",
      age: "",
      mailAddress: "",
      tel: "",
      message: "",
      companyName: "",
      inquiryType: from,
    },
  })

  const onSubmit = async data => {
    console.log("data", data)
    try {
      await fetch(FORM_URL, {
        method: "POST",
        body: provideUrlEncodedFormData(data),
        mode: "no-cors",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      alert("お問い合わせを受け付けました。回答まで今しばらくお待ちください")
    } catch (e) {
      alert("送信に失敗しました。ネットワーク状況を確認してください")
    }
  }
  return (
    <form className="formrun" onSubmit={handleSubmit(onSubmit)}>
      {showCompany && (
        <div className="form-item">
          <label>会社名</label>
          <input
            {...register("companyName")}
            onChange={e => {
              e.persist()
              setValue("companyName", e.target.value)
            }}
            type="text"
            placeholder="株式会社スマートホーム"
          />
        </div>
      )}

      <div className="form-item">
        <label className="required">名前</label>
        <input
          {...register("name")}
          type="text"
          placeholder="田中 太郎"
          onChange={e => {
            e.persist()
            setValue("name", e.target.value)
          }}
        />
      </div>

      {showAge && (
        <div className="form-item">
          <label>年齢</label>
          <div>
            <input
              {...register("age")}
              className="age"
              type="number"
              placeholder="30"
              max="100"
              min="0"
              onChange={e => {
                e.persist()
                setValue("age", e.target.value)
              }}
            />
            歳
          </div>
        </div>
      )}

      <div className="form-item">
        <label className="required">メールアドレス</label>
        <input
          {...register("mailAddress")}
          type="text"
          placeholder="taro.tanaka@smarthome.jp"
          onChange={e => {
            e.persist()
            setValue("mailAddress", e.target.value)
          }}
        />
      </div>

      <div className="form-item">
        <label className="required">電話番号</label>
        <input
          {...register("tel")}
          type="number"
          placeholder="08012345678"
          onChange={e => {
            e.persist()
            setValue("tel", e.target.value)
          }}
        />
      </div>

      <div className="form-item">
        <label className="required">{messageLabel}</label>
        <textarea {...register("message")} rows="6" onChange={(e) => {
              e.persist()
              setValue("message", e.target.value)
            }} />
      </div>

      <input {...register("inquiryType")} type="hidden" />

      <div className="button-container">
        <button className="button primary" type="submit">
          送信
        </button>
      </div>
    </form>
  )
}

function provideUrlEncodedFormData(originalFormData) {
  const result = {}
  Object.keys(originalFormData).map(
    key => (result[FormFieldNames[key]] = originalFormData[key])
  )
  return new URLSearchParams(result).toString()
}

export default Form
